export const FIREBASE_ERROR_CODES = {
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_CREDENTIALS: 'auth/invalid-credential',
    INVALID_PASSWORD: 'auth/invalid-password',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-login-credentials',
    INVALID_EMAIL_OR_PASSWORD: 'auth/invalid-email-or-password',
    INVALID_EMAIL_OR_PASSWORD_CREDENTIALS: 'auth/invalid-email-or-password-credentials  or password or credentials',
    WRONG_PASSWORD: 'auth/wrong-password',
    USER_ALREADY_EXISTS: 'auth/email-already-in-use',
    WEAK_PASSWORD: 'auth/weak-password',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIAL: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    USER_DISABLED: 'auth/user-disabled',
    POPUP_BLOCKED: 'auth/popup-blocked',
};